import '../App.css';
import React, {useState, useEffect, useRef} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { grabData } from "../assets/dataUploader";
import { topicVideos } from "../assets/topicVideos";

function DisplayTopics() {

  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const [wordList, setWordList] = useState([]);
  const [videoUrl, setVideoUrl] = useState('');
  const [selectedTopic, setSelectedTopic] = useState(null);
  const navigate = useNavigate();
  
  const videoRef = useRef(null);
  const wordListRef = useRef(null);

  const [topics, setTopics] = useState([]);

  useEffect(() => {
    const getData = async () => {
      grabData().then(
        data => {
          setData(data);
          window.sessionStorage.setItem("database", JSON.stringify(data));
          setTopics(Object.keys(data));
        }
      ).then(
        value => {
          setLoaded(true);
        }        
      )
    }

    if (!loaded){
      getData();
    }
  });

  const sortByEnglish = (reverse, wL) => {

    if (wL == null){
      wL = [...wordList];
    }

    wL.sort(function(word1, word2){
      if (reverse){
        return word2.english_1.localeCompare(word1.english_1);
      }else{
        return word1.english_1.localeCompare(word2.english_1);
      }
    });

    // console.log(wL);

    setWordList(wL);
  }

  const sortByYoruba = (reverse, wL) => {
    //sort data for render
    if (wL == null){
      wL = [...wordList];
    }

    wL.sort(function(word1, word2){
      if (!reverse) {
        return word1.yoruba_1.localeCompare(word2.yoruba_1);
      }else{
        return word2.yoruba_1.localeCompare(word1.yoruba_1);
      }
    });

    setWordList(wL);
  }

  const updateDisplayWord = (word) => {
    window.sessionStorage.setItem("displayWord", JSON.stringify(word));
    navigate("/word");
  }

  const handleTopicClick = (topic) => {
    setWordList([...data[topic]]);
    setSelectedTopic(topic);
    setVideoUrl(topicVideos[topic] || '');

    // Add slight delay to ensure content is rendered before scrolling
    setTimeout(() => {
      if (topicVideos[topic]) {
        videoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (data[topic].length > 0) {
        wordListRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  return (
    <div className="Home">
      <header className="App-header">
        <h3 style={{textAlign:"center"}}>The Yoruba Dictionary</h3>

        <div className="special-characters">
          {
          topics.map((topic, index) => (
            <button key={index} className="topic-item" onClick={() => handleTopicClick(topic)}> {topic} </button>
          ))}
        </div>
        
        {selectedTopic && videoUrl && (
          <div ref={videoRef} className="video-container" style={{ margin: '3em 0px', textAlign: 'center' }}>
            <iframe
              src={videoUrl}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
        
        {/* In order to clarify, the actual word display begins here*/}
        <div ref={wordListRef} className="grid-container">
          {wordList.map((word, index) => (
            <Link key={index} className="grid-item" onClick={() => {updateDisplayWord(word)}}>
              {word.english_1} , {word.yoruba_1}
              <br />
            </Link>
          ))}
        </div>
      </header>
    </div>
  );
}
  
export default DisplayTopics;